var _path, _path2, _path3, _rect, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdf = function SvgPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E9EC",
    d: "M3.5 4A1.5 1.5 0 0 1 5 2.5h18l7.5 8.625V35.5A1.5 1.5 0 0 1 29 37H5a1.5 1.5 0 0 1-1.5-1.5V4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F5F6",
    stroke: "#888D96",
    strokeWidth: 0.75,
    d: "M8 .625h17.83l7.295 8.39V33.25c0 .621-.504 1.125-1.125 1.125H8a1.125 1.125 0 0 1-1.125-1.125V1.75c0-.621.504-1.125 1.125-1.125Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7BBC2",
    d: "M7.25 22h16.875v3.75a1.5 1.5 0 0 1-1.5 1.5H7.25V22Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.25,
    height: 13.5,
    x: 0.875,
    y: 12.25,
    fill: "#FF5255",
    rx: 1.125
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.348 21.875v-6.363h4.078v.958H17.49v1.74h2.655v.958H17.49v2.707h-1.142ZM12.252 21.875H10.09v-6.363h2.197c1.898 0 3.045 1.19 3.05 3.173-.005 1.99-1.152 3.19-3.085 3.19Zm-1.02-.993h.958c1.332.004 2.004-.73 2.004-2.197 0-1.46-.672-2.184-1.968-2.18h-.994v4.377ZM4.535 21.875v-6.363h2.39c1.46 0 2.238.887 2.242 2.11-.004 1.216-.791 2.1-2.259 2.1h-1.23v2.153H4.535Zm1.143-3.094H6.75c.861-.004 1.248-.487 1.248-1.16 0-.681-.387-1.151-1.248-1.151H5.678v2.311Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#888D96",
    d: "M26 .25v8.625h7.5L26 .25Z"
  })));
};
export default SvgPdf;